<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4">

          </div>           
          <div class="col-md-8">
            <div class="row" style="margin-right:0px;margin-bottom:5px;">
              <div class="col-md-5">
                <div class="form-inline pull-right">
                  <label for="pagesize">Show</label>                    
                  <select id="pagesize" @change="changePageSize" ref="recordPerPage" class="form-control" style="margin-left:5px; margin-right:10px;">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>100</option>
                  </select>             
                </div>
              </div>
              <div class="col-md-7">
                <button class="btn btn-primary" data-toggle="modal" data-target="#modal-filter" style="margin-right:10px;">Filter</button>
                <button v-on:click="inquiry" class="btn btn-primary" style="margin-right:10px;">Search</button>
                <button v-on:click="download" class="btn btn-primary">Download</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="box">      
        <div class="box-body no-padding table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 45px;text-align:right;">#</th>
                <!-- <th style="text-align:center;">Action</th> -->
                <th style="text-align:left;">First Name</th>
                <th style="text-align:left;">Last Name</th>
                <th style="text-align:left;">Membership</th>
                <th style="text-align:center;">Valid From</th>
                <th style="text-align:center;">Valid To</th>
                <th style="text-align:center;">Status</th>
                <th style="text-align:left;">HP No</th>
                <th style="text-align:left;">Email Address</th>               
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in listData" v-bind:key="i">
                <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                <!-- <td style="text-align:center;" nowrap>
                  <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                  </a>
                </td> -->
                <td style="text-align:left;">{{ row.guestFirstName }}</td>
                <td style="text-align:left;">{{ row.guestLastName }}</td>
                <td style="text-align:left;">{{ row.membershipName }}</td>
                <td style="text-align:center;">{{ row.validFrom }}</td>
                <td style="text-align:center;">{{ row.validTo }}</td>
                <td style="text-align:center;">
                  <span v-if="row.status == MEMBERSHIP_SUBMIT" class="badge bg-blue">{{ row.status }}</span>
                  <span v-if="row.status == MEMBERSHIP_PAID" class="badge bg-yellow">{{ row.status }}</span>
                  <span v-if="row.status == MEMBERSHIP_ACTIVE" class="badge bg-green">{{ row.status }}</span>
                  <span v-if="row.status == MEMBERSHIP_EXPIRED" class="badge bg-red">{{ row.status }}</span>                  
                </td>
                <td style="text-align:left;">{{ row.contactNo }}</td>
                <td style="text-align:left;">{{ row.emailAddress }}</td>
                <td hidden>{{ row.id }}</td>
                <td hidden>{{ row.guestId }}</td>
                <td hidden>{{ row.membershipId }}</td>
                <td hidden>{{ row.currencyId }}</td>
                <td><button v-on:click="onDisplay(row)" class="btn btn-sm btn-success pull-right" style="margin-right: 5px;">Detail</button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="box-footer">
          <div class="form-group">
            <label style="width:25px;text-align:right;">
                <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
            </label>
            <label>
                Page
            </label>
            <label>
                <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
            </label>
            <label id="TotalPageText">
              {{ totalPages }}                
            </label>
            <label style="width:35px;text-align:center;">
                <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
            </label>
            <label style="width:25px;text-align:left;">
                <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Email</label>
                <div class="col-md-10">
                    <input type="text" id="filterEmail" v-model="searchParam.emailAddress" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">First Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterFirstName" v-model="searchParam.firstName" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Last Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterLastName" v-model="searchParam.lastName" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Membership Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterMembershipName" v-model="searchParam.membershipName" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Key Date</label>
                <div class="col-md-10">
                  <datepicker v-if="showKeydate" :value=searchParam.keyDate :format=DATE_FORMAT :input-attr="{ 'id': 'keyDate' }" :input-style="{ 'width': '100%' }"></datepicker>
                </div>                     
              </div>             
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-10">
                  <input type="text" id="filteStatus" v-model="searchParam.status" style="width:100%">
                </div>                     
              </div>                                                                                         
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import config from '../../config'
import $ from 'jquery'
import moment from 'moment'
import datepicker from '../../components/widgets/DatePicker'
import select2 from '../../components/widgets/Select2'

const MEMBERSHIP_SUBMIT = 'Submit'
const MEMBERSHIP_PAID = 'Paid'
const MEMBERSHIP_ACTIVE = 'Active'
const MEMBERSHIP_EXPIRED = 'Expired'
const MODE_VIEW = 'read'

export default {
  name: 'GuestMembership',
  components: {
    datepicker, select2
  },
  data() {
    return {
      MEMBERSHIP_SUBMIT: MEMBERSHIP_SUBMIT,
      MEMBERSHIP_PAID: MEMBERSHIP_PAID,
      MEMBERSHIP_ACTIVE: MEMBERSHIP_ACTIVE,
      MEMBERSHIP_EXPIRED: MEMBERSHIP_EXPIRED,
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      currentStatus: null,
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      keyWords: '',
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'FirstName'
      },
      listProject: null,
      projectCheckInOut: null,
      guestCheckInOut: null,
      listGuestMembership: null,
      guestMembershipCheckInOut: null,
      kanban: true,
      grid: false,
      searchParam: {
        emailAddress: '',
        firstName: '',
        lastName: '',
        membershipName: '',
        keyDate: '',
        status: ''
      },
      showKeydate: false
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize

    this.searchParam.keyDate = ''
    this.showKeydate = false
    this.$nextTick(() => {
      this.showKeydate = true
    })
    this.inquiry()
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      if (this.inquiryParam.WhereClause === '') {
        this.inquiryParam.WhereClause = 'GuestGroup.GuestId IS NULL'
      }

      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'Membership.ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Guest', 'get', '/api/Guest/Membership?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      let params = {
        id: row.guestId,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'Guest Form', params: params })
    },
    onApplyFilter() {
      var filterParams = []
      filterParams.push(['GuestGroup.GuestId', 'IS', 'NULL'])
      if (this.searchParam.emailAddress !== '') {
        filterParams.push(['Guest.EmailAddress', 'like', '\'' + this.searchParam.emailAddress.replace('*', '%') + '\''])
      }

      if (this.searchParam.firstName !== '') {
        filterParams.push(['Guest.FirstName', 'like', '\'' + this.searchParam.firstName.replace('*', '%') + '\''])
      }

      if (this.searchParam.lastName !== '') {
        filterParams.push(['Guest.LastName', 'like', '\'' + this.searchParam.lastName.replace('*', '%') + '\''])
      }

      if (this.searchParam.membershipName !== '') {
        filterParams.push(['Membership.Name', 'like', '\'' + this.searchParam.membershipName.replace('*', '%') + '\''])
      }

      if ($('#keyDate').val() !== '') {
        let keyDate
        keyDate = moment($('#keyDate').val(), this.DATE_FORMAT)
        keyDate = moment(keyDate).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
        keyDate = this.convertToUtcTime(keyDate, this.DATETIME_FORMAT_ISO)
        filterParams.push(['GuestMembership.ValidFrom', '<=', '\'' + keyDate + '\''])
        filterParams.push(['GuestMembership.ValidTo', '>=', '\'' + keyDate + '\''])
      }

      if (this.searchParam.status !== '') {
        filterParams.push(['GuestMembership.status', '=', '\'' + this.searchParam.status + '\''])
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.inquiry()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.firstName = ''
      this.searchParam.lastName = ''
      this.searchParam.membershipName = ''
      this.searchParam.status = ''

      this.searchParam.keyDate = ''
      this.showKeydate = false
      this.$nextTick(() => {
        this.showKeydate = true
      })
    },
    download() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'Membership.ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Guest', 'get', '/api/Guest/Download?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null, 'blob')
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))

          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'GuestMembership.xls')
          document.body.appendChild(link)
          link.click()
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  width: 250px;
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.icheckbox_flat-green,
.iradio_flat-green {
    display: inline-block;
    *display: inline;
    vertical-align: middle;
    margin: 0;
    padding: 0;
    width: 20px;
    height: 20px;
    background: url('/static/img/green.png') no-repeat;
    border: none;
    cursor: pointer;
}

.icheckbox_flat-green {
    background-position: 0 0;
}
    .icheckbox_flat-green.checked {
        background-position: -22px 0;
    }
    .icheckbox_flat-green.disabled {
        background-position: -44px 0;
        cursor: default;
    }
    .icheckbox_flat-green.checked.disabled {
        background-position: -66px 0;
    }

.iradio_flat-green {
    background-position: -88px 0;
}
    .iradio_flat-green.checked {
        background-position: -110px 0;
    }
    .iradio_flat-green.disabled {
        background-position: -132px 0;
        cursor: default;
    }
    .iradio_flat-green.checked.disabled {
        background-position: -154px 0;
    }

.datetime-picker input {
  height: 34px !important;
}


.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// GuestMembership.vue?54bbf9cc